<template>
  <div>
    <canvas id="c"></canvas>
  </div>
</template>

<script>
export default {
  name: 'JjeBackground',
  data() {
    return {
      canvas: null,
      ctx: null,
      chinese: "010110",
      font_size: 10,
      columns: 0,
      drops: [],
    };
  },
  mounted() {
    this.canvas = document.getElementById("c");
    this.ctx = this.canvas.getContext("2d");
    this.initCanvas();
    this.initDrops();
    setInterval(this.draw, 50);

    // 监听窗口大小变化
    window.addEventListener('resize', this.initCanvas);
  },
  beforeDestroy() {
    // 移除监听器以避免内存泄漏
    window.removeEventListener('resize', this.initCanvas);
  },
  methods: {
    initCanvas() {
      // 设置 canvas 尺寸为整个视口大小
      this.canvas.width = window.innerWidth;
      this.canvas.height = Math.max(document.documentElement.scrollHeight, document.documentElement.clientHeight);
      this.columns = this.canvas.width / this.font_size;

      // 立即调用 draw 方法以确保新尺寸立即生效
      //this.draw();
    },

    initDrops() {
      for (let x = 0; x < this.columns; x++) {
        this.drops[x] = 1;
      }
    },
    draw() {
      this.ctx.fillStyle = "rgba(0,0,0,0.05)";
      this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);

      this.ctx.fillStyle = "#0F0";
      this.ctx.font = this.font_size + "px arial";

      for (let i = 0; i < this.drops.length; i++) {
        const text = this.chinese[Math.floor(Math.random() * this.chinese.length)];

        this.ctx.fillText(text, i * this.font_size, this.drops[i] * this.font_size);

        if (this.drops[i] * this.font_size > this.canvas.height && Math.random() > 0.975) {
          this.drops[i] = 0;
        }
        this.drops[i]++;
      }
    },
  },

};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

body {
  background: black;
}

canvas {
  display: block;
  position: fixed; /* 确保 canvas 固定在视窗中 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1; /* 将背景置于所有其他内容之下 */
}
</style>
